import React from 'react';
import SectionTitle from '../sectionTitle';
// import Carussel from './Carussel';
import logoProReno from '../../images/logo-black-pro-reno.png';

const Wrapper = () => (
  <div className="MainWrapper / -lg:px-16 flex flex-col justify-between h-full px-3 pt-12 pb-48">
    <SectionTitle title="Télécharger les fiches d'Autocontrôle et de Réception" />
    <div className="h-full">
      {/* <div className="overflow-x-hidden">
        <Carussel />
      </div> */}
      <div>
        <p className="text-xl text-center font-semibold mb-3">
          Accéder gratuitement à l'ensemble des ressources
          <br/>
          et des outils PROFEEL sur <a href="https://www.proreno.fr/" className="textGreen" target="_blank">www.proreno.fr</a>
        </p>
        <a href="https://www.proreno.fr/" className="textGreen" target="_blank">
          <img src={logoProReno}  style={{width:300 + 'px', margin: 'auto'}} alt="arrowvector" />
        </a>
      </div>
    </div>
  </div>
);

export default Wrapper;
